"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Utils_1 = require("@/Utils");
const FilterList_1 = __importDefault(require("@/Components/UI/FilterList"));
const Hooks_1 = require("@/Hooks");
const FILTER_DELAY = 700;
const generateActiveFilters = (filters, setSearch) => {
    const searchParams = window.location.search;
    const newFilter = [];
    if (searchParams) {
        const urlParams = new URLSearchParams(searchParams);
        const uniqueKeys = [...new Set(filters.map(item => item.items[0].key))];
        const values = [];
        uniqueKeys.forEach(key => {
            const paramValues = urlParams.get(key);
            if (paramValues) {
                const params = paramValues.split('","');
                params.forEach(param => {
                    values.push({
                        key,
                        value: param
                    });
                });
            }
        });
        filters.forEach(filter => {
            filter.items.forEach(item => {
                if (values.some(param => param.key === item.key && param.value === item.name)) {
                    newFilter.push(item);
                }
            });
        });
        const searchValue = urlParams.get('query');
        searchValue && setSearch(searchValue);
    }
    return newFilter;
};
const CategoryFilterContainer = ({ filters, setFilterParam, isFilterOpen, setIsFilterOpen, productsAmount, newPageSize, setNewPageSize, initialPageSize }) => {
    const [search, setSearch] = (0, react_1.useState)('');
    const [filterSearchParams, setFilterSearchParams] = (0, react_1.useState)(window.location.search);
    const [activeFilters, setActiveFilters] = (0, react_1.useState)(() => generateActiveFilters(filters, setSearch));
    const debouncedSearch = (0, Hooks_1.useDebounce)(search, FILTER_DELAY);
    const debouncedActiveFilters = (0, Hooks_1.useDebounce)(activeFilters, FILTER_DELAY);
    const { isDesktopSmall } = (0, Hooks_1.useDevice)();
    const { t } = (0, Hooks_1.useTranslate)();
    const clearAll = (0, react_1.useCallback)(() => {
        setSearch('');
        setActiveFilters([]);
        setFilterSearchParams('');
    }, []);
    (0, react_1.useEffect)(() => {
        if (debouncedActiveFilters.length > 0) {
            const newParams = (0, Utils_1.generateFilterParams)(debouncedActiveFilters, debouncedSearch);
            if (filterSearchParams !== newParams) {
                setFilterSearchParams(newParams);
            }
        }
        else {
            window.history.replaceState(null, null, debouncedSearch ? `?query=${debouncedSearch}` : '');
            const newParams = debouncedSearch ? `?query=${debouncedSearch}` : '';
            if (filterSearchParams !== newParams) {
                setFilterSearchParams(debouncedSearch ? `?query=${debouncedSearch}` : '');
            }
        }
    }, [JSON.stringify(debouncedActiveFilters), debouncedSearch, newPageSize]);
    (0, react_1.useEffect)(() => {
        if (filters) {
            setActiveFilters(generateActiveFilters(filters, setSearch));
        }
    }, [filters]);
    (0, react_1.useEffect)(() => {
        filterSearchParams
            ? window.history.replaceState(null, null, filterSearchParams)
            : window.history.replaceState(null, null, window.location.pathname);
        setNewPageSize(initialPageSize);
        setFilterParam((0, Utils_1.generateParam)());
    }, [filterSearchParams]);
    if (!isFilterOpen && isDesktopSmall) {
        return null;
    }
    return (react_1.default.createElement(FilterList_1.default, { filters: filters, setIsFilterOpen: setIsFilterOpen, productsAmount: productsAmount, clearFilters: clearAll, search: search, activeFilters: activeFilters, setSearch: setSearch, setActiveFilters: setActiveFilters, showMoreLabel: t('/haldex/filter/show_more_products'), isProductListing: true }));
};
exports.default = (0, react_1.memo)(CategoryFilterContainer);
